
import { OpaccFormElementAutoComplete } from './classes/opacc.class.form.element.autocomplete.js';
import { OpaccFormElementTimePicker } from './classes/opacc.class.form.element.timepicker.js';
import { OpaccFormElementDatePicker } from './classes/opacc.class.form.element.datepicker.js';
import { OpaccFormElementWysiwyg } from './classes/opacc.class.form.element.wysiwyg.js';
import { OpaccFormElementCaptcha } from './classes/opacc.class.form.element.captcha.js';
import { OpaccFormMaterial } from './classes/opacc.class.form.material.js';

/**
 * Clientseitige Funktionalität im Modul "Form"
 *
 * @module form
 */

export const opaccFormElementAutoCompletePlugin = new OpaccFormElementAutoComplete();
export const opaccFormElementTimePickerPlugin = new OpaccFormElementTimePicker();
export const opaccFormElementDatePickerPlugin = new OpaccFormElementDatePicker();
export const opaccFormElementWysiwygPlugin = new OpaccFormElementWysiwyg();
export const opaccFormElementCaptchaPlugin = new OpaccFormElementCaptcha();
export const opaccFormMaterialplugin = new OpaccFormMaterial();